export default __webpack_public_path__ + "static/media/google-logo.17ba8bf5.svg";